import {
  Link,
  sidebarConfig,
  useSidebarOpenState,
  useSidebarPinState,
} from '@backstage/core-components';
import { IconButton, makeStyles } from '@material-ui/core';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { manewcoTokens } from '@platform/plugin-platform-react';
import { LogoFull } from './LogoFull';
import { LogoIcon } from './LogoIcon';

const useSidebarLogoStyles = makeStyles(theme => {
  const MANEWCO = manewcoTokens(theme);
  return {
    root: {
      width: '100%',
      height: 3 * sidebarConfig.logoHeight,
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
      marginBottom: -14,
    },
    link: {
      width: sidebarConfig.drawerWidthClosed,
      marginLeft: 24,
    },
    /** Menu réduit : logo et bouton empilés, centrés dans la colonne d'icônes. */
    closed: {
      flexFlow: 'column nowrap',
      justifyContent: 'center',
      height: 'auto',
      padding: '16px 0 4px',
      marginBottom: 0,
      gap: 6,
    },
    closedLink: { display: 'flex', justifyContent: 'center', width: '100%' },
    toggle: {
      marginLeft: 'auto',
      marginRight: 12,
      width: 28,
      height: 28,
      borderRadius: 9,
      color: MANEWCO.navText,
      '&:hover': { background: MANEWCO.hover, color: MANEWCO.primary },
    },
    toggleClosed: { margin: 0 },
  };
});

/**
 * Logo et bouton de réduction du menu. Réduire = désépingler la barre : elle passe aux icônes
 * (le survol ne la rouvre pas, voir `disableExpandOnHover` dans Sidebar.tsx). L'état est
 * mémorisé par Backstage.
 */
export const SidebarLogo = () => {
  const classes = useSidebarLogoStyles();
  const { isOpen } = useSidebarOpenState();
  const { isPinned, toggleSidebarPinState } = useSidebarPinState();
  const expanded = isOpen && isPinned;

  if (!expanded) {
    return (
      <div className={`${classes.root} ${classes.closed}`}>
        <Link to="/" underline="none" className={classes.closedLink} aria-label="Home">
          <LogoIcon />
        </Link>
        <IconButton
          className={`${classes.toggle} ${classes.toggleClosed}`}
          aria-label="Agrandir le menu"
          title="Agrandir le menu"
          onClick={toggleSidebarPinState}
        >
          <ChevronRightIcon fontSize="small" />
        </IconButton>
      </div>
    );
  }

  return (
    <div className={classes.root}>
      <Link to="/" underline="none" className={classes.link} aria-label="Home">
        <LogoFull />
      </Link>
      <IconButton
        className={classes.toggle}
        aria-label="Réduire le menu"
        title="Réduire le menu"
        onClick={toggleSidebarPinState}
      >
        <ChevronLeftIcon fontSize="small" />
      </IconButton>
    </div>
  );
};
